<template>
  <div class="inners">
    <div class="right">
      <div class="titles">{{ $t("repairOrder.title") }}</div>
      <div>
        <div>
          <el-button size="small" type="primary" @click="handleClick">{{ $t("repairOrder.des") }}</el-button>
        </div>
        <div style="margin-top: 15px">
          <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              :header-cell-style="{'text-align': 'left', fontSize:'13px',color:'color: rgba(0,0,0,.85);', fontWeight: '500',background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
          >
            <el-table-column prop="id" :label="$t('repairOrder.table.no')" width="180"/>
            <el-table-column prop="title" :label="$t('repairOrder.table.title')" :show-overflow-tooltip="true"/>
            <el-table-column prop="status" :label="$t('repairOrder.table.status')" width="150">
              <template #default="{row}">
                <span v-if="row.status===1" style='color:red'>{{ $t('common.untreated') }}</span>
                <span v-else-if="row.status===2" style='color:green'>{{ $t('common.cds66') }}</span>
                <span v-else-if="row.status===3" style='color:#70a2f7'>{{ $t('system.workorder.doing') }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" :label="$t('repairOrder.update.time')" width="180"/>
            <el-table-column :label="$t('repairOrder.setting')" :width="lang==='en'?150:120">
              <template #default="{ row, column, $index }">
                <el-button v-if="row.status!==2" link type="primary" @click="handleClickReplay(row)">{{
                    $t('repairOrder.show')
                  }}
                </el-button>
                <el-button v-else link type="primary" @click="handleClickInfo(row)">{{
                    $t('repairOrder.show')
                  }}
                </el-button>

                <ConfirmDeletePopover
                    :visible="row.popoverVisibleDelete"
                    :width="164"
                    :message="$t('sys.message.ask.delete')"
                    :ref="`popover-${$index}`"
                    @update:visible="(value) => (row.popoverVisibleDelete = value)"
                    @confirm:delete="handleClickDelete(row)"
                >
                  <template #settings>

                    <el-button link type="danger"
                               @click.native.stop="row.popoverVisibleDelete = true">
                      {{ $t('common.delete') }}
                    </el-button>
                  </template>
                </ConfirmDeletePopover>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
                size="small"
                v-model:current-page="current"
                v-model:page-size="size"
                v-if="total"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from "vue";
import {useRouter} from "vue-router";

import BasicCard from "./Basic/BasicCard.vue";
import {deleteWorkOrder, getMailOpinionList} from "@/api/usercenter";
import {ElMessage} from "element-plus";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {useStore} from "vuex";

const router = useRouter();
const store = useStore()

const tableData = ref([]);
const loading = ref(false)
const lang = computed(() => store.state.system.langLocal)

const current = ref(1);
const size = ref(10);
const total = ref(0);
const handleCurrentChange = (page) => {
  current.value = page;
  getMailOpinionListApis();
};

const getMailOpinionListApis = async () => {
  loading.value = true;
  const res = await getMailOpinionList({
    pageNo: current.value,
    pageSize: size.value,
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  const {records} = res.result;
  tableData.value = records;
  current.value = res.result.current;
  size.value = res.result.size;
  total.value = res.result.total;
  loading.value = false

}
const handleClick = () => {
  router.push("/personal/createdRepairOrder");
};

const handleClickInfo = (row) => {
  router.push({path: '/personal/repairOrderDetails', query: {id: row.id}})
}

const handleClickDelete = async (row) => {
  loading.value = true;
  const {id} = row
  const res = await deleteWorkOrder({
    id: id,
  })
  if (res.code !== 200) {
    ElMessage.error(res.message);
    return
  }
  await getMailOpinionListApis()
  loading.value = false
}
const handleClickReplay = (row) => {
  router.push({path: '/personal/repairOrderDetails', query: {id: row.id}})
}

onMounted(async () => {
  await getMailOpinionListApis()
})
</script>

<style lang="less" scoped>
@import "./less/Tables.less";
@import "../../less/page.less";

.inners {
  width: auto !important;
  max-width: 1200px !important;

  .right {
    height: auto !important;
    min-height: 640px !important;
    padding-bottom: 20px !important;
  }
}

:deep(.el-table .cell) {
  font-size: 14px !important;
  font-weight: normal !important;
}
</style>
